import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-receiptref-range',
  templateUrl: './receiptref-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ReceiptRefRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
